
let searchDataArray = (i, v) => {
  try {
    v = v.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    let keyCountry = i.c_Pais.toLocaleLowerCase()
    let name = i.descripcion.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return keyCountry.indexOf(v) > -1 || name.indexOf(v) > -1
  } catch (exp) {
  }
}

let searchFilter = (i, qT, iT) => {
  return searchDataArray(i, qT)
}

let searchQuerySelection = (i, v) => {
  let items = []
  items = i.filter(e => {
    if (searchDataArray(e, v)) {
      return e
    }
  })
  return items
}

let searchFn = (s, v) => {
  return v && v !== s
}

const searchItem = () => {
  return {
    dataArray: (i, v) => { return searchDataArray(i, v) },
    filter: (i, qT, iT) => { return searchFilter(i, qT, iT) },
    querySelection: (i, v) => { return searchQuerySelection(i, v) },
    search: (s, v) => { return searchFn(s, v) }
  }
}

export default searchItem



// WEBPACK FOOTER //
// ./src/search-country/index.js